import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/_core/hooks/useAuth";

const clerkGlobal = () => (window as any).Clerk;

/**
 * Bridges Clerk sign-in to the app's session cookie system.
 * Polls for window.Clerk to finish loading, then fires the token exchange.
 */
export default function ClerkSessionBridge() {
  const { user, loading } = useAuth();
  const exchanged = useRef(false);
  const [clerkReady, setClerkReady] = useState(false);

  // Poll until window.Clerk is loaded
  useEffect(() => {
    if (clerkReady) return;
    const check = () => {
      const c = clerkGlobal();
      if (c && c.loaded) {
        setClerkReady(true);
      } else {
        setTimeout(check, 200);
      }
    };
    check();
  }, [clerkReady]);

  // Fire the exchange once Clerk is ready and we know there's no app session
  useEffect(() => {
    if (!clerkReady) return;
    if (loading) return;
    if (user) return;
    if (exchanged.current) return;
    const clerk = clerkGlobal();
    if (!clerk?.user) return;
    if (window.location.pathname === "/sso-callback") return;
    exchanged.current = true;

    clerk.session?.getToken().then(async (token: string | null) => {
      if (!token) { exchanged.current = false; return; }
      try {
        const res = await fetch("/api/clerk/exchange", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ token }),
        });
        if (res.ok) {
          window.location.reload();
        } else {
          exchanged.current = false;
        }
      } catch {
        exchanged.current = false;
      }
    });
  }, [clerkReady, loading, user]);

  return null;
}
